import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { ConfirmPasswordDialogComponent } from '../../popup/confirm-password-dialog/confirm-password-dialog.component';

import { JsonObject } from '@angular-devkit/core';
import { PaymentConfirmDialogComponent } from '../../popup/payment-confirm-dialog/payment-confirm-dialog.component';
import { CommonService } from "../../../_common/_service/user.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { BeforePaymentConfirmDialogComponent } from '../../popup/beforepayment-confirm-dialog/beforepayment-confirm-dialog.component';

@Component({
  selector: 'app-international-dthservices',
  templateUrl: './international-dthservices.component.html',
  styleUrls: ['./international-dthservices.component.scss']
})
export class InternationalDTHServicesComponent implements OnInit {

  countryList: any;
  serviceList: any;
  operatorList: any;
  productList: any;

  IsDataGet = false;
  IsOprtDataGet = false;
  isGetproductList = false;
  recentReceiver: any;
  submitted = false;

  balance: any;
  public payDTHMoneyForm: FormGroup;
  stringJson: any;
  stringObject: any;
  UsertBal: any;
  countryCode: any;
  channelList: any;
  userorderdetailList: any;
  ServiceName: any;
  cUser: any;
  finalAmount: any;
  commissionFee: any;
  commissionTotal: any;
  amt: any;
  data: any;
  commissionList: any;
  FlatChargesByCountry: any;

  show = 2;
  OperatorName: any;
  maxDate = new Date();
  currentUser: any;
  token: any;
  OptionList: any;
  serviceCode: any;
  countryIsdcode: any;
  public CountryFilterCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();
  countryname: any;
  loadingspinner: boolean = false;

  constructor(private authService: AuthService, private router: Router,
    private route: ActivatedRoute, public dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService, private _service: CommonService) {

    this.countryIsdcode = localStorage.getItem('countryIsdcode');

    this.payDTHMoneyForm = this.fb.group({
      ISD: [null, [Validators.required]],
      PaymentModeCode: ["RRP"],
      Amount: [null, [Validators.required]],
      product_id: [null],
      //AccountCode: [null, [Validators.required]],
      account_number: [null, [Validators.required]],
      CountryIsdCode: [this.countryIsdcode],
      Comment: [null],
      BeneficiaryName: [null, [Validators.pattern("^[a-zA-Z ]*$")]],
      ChannelFrom: [null],
      AccountCodeFrom: [null],
      MobileNoFrom: [null],
      service_id: [null, [Validators.required]],
      operator_id: [null, [Validators.required]],
      ServiceCode: [null],
      DeviceType: "web"

    })

  }
  ngOnInit() {
    
    this.token = this.tokenStorageService.getToken();
     this.serviceCode = this.route.snapshot.queryParams.serviceCode;
    if (this.token) {
      this.currentUser = this.tokenStorageService.getUser();
      this.UsertBal = this.tokenStorageService.getUsertBal();
      this.getdthcountryList();
      this.getchannelList();
      this.viewTransactions();

      // listen for search field value changes
      this.CountryFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterCountry();
        });
    }
    else {
      this._service.callMethodOfSecondComponent();
    }


  }
  get f() { return this.payDTHMoneyForm.controls; }

  Back() {

    this.router.navigate(['/Go-on']);
  }

  selectservicebycountry_id(countryName:any) {
    this.countryname = countryName;
    this.submitted = false;

    this.getdthServicesList();

    this.IsDataGet = false;
    this.IsOprtDataGet = false;
    this.isGetproductList = false;

    this.f.ChannelFrom.setValue(null);
    this.f.AccountCodeFrom.setValue(null);
    this.f.MobileNoFrom.setValue(null);

    this.f.Comment.setValue(null);
    this.f.BeneficiaryName.setValue(null);
    
    this.f.operator_id.setValue(null);
    this.f.service_id.setValue(null);
    this.f.account_number.setValue(null);
    this.f.Amount.setValue(null);
    this.commissionFee = 0;
    this.commissionTotal = 0;
    this.amt = 0;


  }
  country_id() {
    this.submitted = false;

    this.getdthServicesList();


  }
  service_id() {
    this.submitted = false;

    this.getdthOperatorList();


  }
  operator_id(operatorname: any) {
    this.submitted = false;
    this.OperatorName = operatorname;
    this.getdthProductsList();


  }

  

  getdthcountryList() {
    this.submitted = true;

    this.authService.getdthcountryList(this.currentUser.serviceid).subscribe(response => {

      if (response.countries) {
        this.countryList = response.countries;
        // this.toastr.successToastr(response.Message, AppConstant.success);
      } else {
        this.toastr.error(response, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }

  filterCountry() {

    if (this.CountryFilterCtrl.value) {
      return this.countryList.filter((x: { country: string; }) => x.country.toLowerCase().startsWith(this.CountryFilterCtrl.value.toLowerCase()));
    } else {
      return this.countryList;
    }
  }

  getdthServicesList() {    
    this.submitted = true;
    this.authService.getdthServicesList(this.f.ISD.value, this.currentUser.serviceid).subscribe(response => {
      if (response) {
        
        this.serviceList = response.services;
        this.IsDataGet = true;
      } else {
        this.toastr.error(response, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {

        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }

  getdthOperatorList() {
    
    this.submitted = true;

    this.authService.getdthOperatorList(this.f.ISD.value, this.f.service_id.value, this.currentUser.serviceid).subscribe(response => {
      if (response) {
        
        this.operatorList = response.operators;
        this.IsOprtDataGet = true;
      } else {
        this.toastr.error(response, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {

        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }


  getdthProductsList() {
    
    this.submitted = true;

    this.authService.getdthProductsList(this.f.operator_id.value, this.currentUser.serviceid).subscribe(response => {
      if (response) {
        
        this.productList = response;
        this.isGetproductList = true;
      } else {
        this.toastr.error(response, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {

        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }

  selectedProduct(data: any) {
    

    if (data.value == "") {
      this.commissionFee = 0;
      this.commissionTotal = 0;

    }
    if (data.value) {

      if ((this.f.PaymentModeCode.value && this.serviceCode) && this.show != 1) {
        this.getServiceCommissionList(data.value, this.f.PaymentModeCode.value, this.serviceCode);
      }
      // for optin 1 popup :- AccountCodeFrom,form :- ServiceCode
      else if ((this.f.PaymentModeCode.value && this.serviceCode && this.f.AccountCodeFrom.value) && this.show == 1) {
        this.getServiceCommissionList(data.value, this.serviceCode, this.f.AccountCodeFrom.value);
      }
      else {
        this.toastr.error("Selected Proper Option", 'Error');
      }
      // Amount= ; AddService_Code=; PayService_Code= 
    }

  }
  getServiceCommissionList(Amountrequested: any, SelectedrblOptionCode: any, SelectedNetworkCode: any) {

    //this.submitted = true;
    // var body = { Amount: Amountrequested, AddService_Code: SelectedrblOptionCode, PayService_Code: SelectedNetworkCode};
    this.authService.getServiceCommissionList(Amountrequested, SelectedrblOptionCode, SelectedNetworkCode, this.currentUser.serviceid).subscribe((response:
      { apiData: any; apiStatus: any; apiMessage: string | undefined; }) => {
      if (response.apiStatus == true) {

        this.commissionList = response.apiData;
        this.amt = Amountrequested;
        this.commissionFee = this.commissionList.totalCommission;
        this.commissionTotal = this.commissionList.totalAmount;

      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }

  

  payMoney(post: any) {
    

    this.submitted = true;

    if (post.Amount == null || post.Amount == 'undefined' || this.amt == null || this.amt == 'undefined') {

      this.toastr.error("Error Occur Refresh Page", 'Error');

    }

    else {
      if (this.payDTHMoneyForm.valid) {
        this.loadingspinner = true; 
        //AccountCode == channel selected code
        //channel == channel selected name

        var PayServicsReq = null;
        var AddServicsReq = null;
        if (this.show == 1) {
          //pop up 
          AddServicsReq = {
            Channel: post.ChannelFrom,
            Amount: parseFloat(post.Amount), MobileMoneySource: post.MobileNoFrom,
            AccountCode: post.AccountCodeFrom, CountryIsdCode: post.ISD
          }
          //form 
          PayServicsReq = {
            account_number: post.account_number,
            product_id: String(post.operator_id),

            AmountinUsd: parseFloat(post.Amount),
            AccountCode: this.serviceCode,
          }
        }
        else if (this.show == 2 || this.show == 3) {
          //pop up
          AddServicsReq = {
            Amount: parseFloat(post.Amount),
            AccountCode: post.PaymentModeCode
          }
          //form 
          PayServicsReq = {
            account_number: post.account_number,
            product_id: String(post.operator_id),

            AmountinUsd: parseFloat(post.Amount),
            AccountCode: this.serviceCode
          }
        }

        //
        var post1 = {
          //form
          PayServicsReq: JSON.stringify(PayServicsReq),
          //popup
          AddServicsReq: JSON.stringify(AddServicsReq),
          ServiceCode: this.serviceCode,
          PaymentModeCode: post.PaymentModeCode,
          DeviceType: "web",
          BeneficiaryName: post.BeneficiaryName,
          Comment: post.Comment
        }

        // Convert String obect to JSON
        this.stringJson = JSON.stringify(post1);
        ////////console.log("String json object :", this.stringJson);

        //  // ConvertjSON to an object
        //  this.stringObject = JSON.parse(this.stringJson);
        //  ////////console.log("JSON object -", this.stringObject);

        this.authService.payDTH(this.stringJson, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; transactionStatus: any }) => {
          
          this.loadingspinner = false; 
          if (response.apiStatus == true && response.apiData.transactionStatus == 2) {
            this.data = response.apiData;
            ////////console.log("data succ response -", this.data);
            this.openPaymentConfirmDialog(this.data);
            //this.payDTHMoneyForm.reset();
            this.submitted = false;

            this.IsDataGet = false;
            this.IsOprtDataGet = false;
            this.isGetproductList = false;
            this.IsDataGet = false;
            this.f.ChannelFrom.setValue(null);
            this.f.AccountCodeFrom.setValue(null);
            this.f.MobileNoFrom.setValue(null);

            this.f.Comment.setValue(null);
            this.f.BeneficiaryName.setValue(null);
            this.f.ISD.setValue(null);
            this.f.operator_id.setValue(null);
            this.f.service_id.setValue(null);
            this.f.account_number.setValue(null);
            this.f.Amount.setValue(null);
            this.commissionFee = 0;
            this.commissionTotal = 0;

            this.tokenService.updateMessagetoken('token'); //after payment succeful done then update userinfo& bal


          }
          //else if (response.apiStatus == true && response.apiData.transactionStatus != 2) {
          //  this.toastr.error(response.apiMessage, 'Error');
          //  this.submitted = false;

          //  this.IsDataGet = false;
          //  this.IsOprtDataGet = false;
          //  this.isGetproductList = false;
          //  this.IsDataGet = false;
          //  this.f.ChannelFrom.setValue(null);
          //  this.f.AccountCodeFrom.setValue(null);
          //  this.f.MobileNoFrom.setValue(null);

          //  this.f.Comment.setValue(null);
          //  this.f.BeneficiaryName.setValue(null);
          //  this.f.ISD.setValue(null);
          //  this.f.operator_id.setValue(null);
          //  this.f.service_id.setValue(null);
          //  this.f.account_number.setValue(null);
          //  this.f.Amount.setValue(null);
          //  this.commissionFee = 0;
          //  this.commissionTotal = 0;
          //  this.tokenService.updateMessagetoken('token');

          //}

          else {
            this.toastr.error(response.apiMessage, 'Error');
          }
        }, (err: any) => {
            this.loadingspinner = false; 
          if (err.error instanceof Error) {

            this.toastr.error(err.error, 'Error');
          } else {

            this.toastr.error(err.error, 'Error');
          }
        }
        );
      }
    }

  }

  openPaymentConfirmDialog(data: any) {
    const dialogRef = this.dialog.open(PaymentConfirmDialogComponent, {
      width: '350px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      window.location.reload();
    });

  }




  viewTransactions() {

    this.authService.getUserOrdersdetails1('IDR', this.currentUser.serviceid).subscribe(response => {
      if (response.apiStatus == true) {
        this.userorderdetailList = response.apiData;
      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }

  getchannelList() {
    this.submitted = false;

    this.authService.getchannelList(this.serviceCode, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {


      if (response.apiStatus == true) {
        this.OptionList = response.apiData;
        ////////console.log(this.OptionList);

      }
      else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
        this.toastr.warning(response.apiMessage, 'Warning');
        this._service.callMethodOfSecondComponent();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }


  openDialog(post: any) {

    this.submitted = true;
    if (this.payDTHMoneyForm.valid) {
      post.serviceName = 'International Gift Voucher';
      post.commissionFee = this.commissionFee;
      post.OperatorName = this.OperatorName;
      post.MobileMoneySource = post.account_number;
      post.beneficiary_country = this.countryname;
      post.beneficiary_phone = post.account_number;
      const dialogRef = this.dialog.open(BeforePaymentConfirmDialogComponent, {
        width: '450px',
        disableClose: true,
        hasBackdrop: true, // or false, depending on what you want
        autoFocus: false,
        maxHeight: '90vh', //you can adjust the value as per your view
        data: post
      });

      dialogRef.afterClosed().subscribe(result => {
        ;
        if (result !== undefined && result !== null && result) {

          this.payMoney(post);
        }
      });

    }
  }

}
